// extracted by mini-css-extract-plugin
module.exports = {"formCancel":"UploadAnalysisModal_formCancel__33h9X","formButtons":"UploadAnalysisModal_formButtons__2jl7a"};